import React from 'react'
import ReactDOM from 'react-dom'
import { func, object, number } from 'prop-types'

const Backdrop = ({ parent, onClick, zIndex }) => (
  ReactDOM.createPortal(
    <div className="backdrop" onClick={onClick}>
      <style jsx>
        {`
          .backdrop {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;

            z-index: ${zIndex};

            background-color: #1a344f;
            opacity: 0.8;
          }
        `}
      </style>
    </div>,
    parent
  )
)

Backdrop.propTypes = {
  parent: object.isRequired,
  onClick: func,
  zIndex: number,
}

Backdrop.defaultProps = {
  zIndex: 2,
}
export default Backdrop
